import {NgModule} from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './auth/auth.guard';
import {InteractiveAnalysesResolver} from './resolver/interactive-analyses.resolver';
import {PdfViewerRoute} from '@adnova/jf-ng-components';


const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always'
};

const routes: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: 'overview',
    loadChildren: () => import('./modules/overview/overview.module').then(m => m.OverviewModule),
    canActivate: [AuthGuard],
    resolve: [InteractiveAnalysesResolver],
    data: {
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'interactive-analysis',
    loadChildren: () => import(
      './routes/interactive-analysis-routing.module'
      ).then(m => m.InteractiveAnalysisRoutingModule),
    canActivate: [AuthGuard],
    resolve: [InteractiveAnalysesResolver],
    data: {
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'widget/utility-widget',
    loadChildren: () => import('./modules/widget/utility-widget/utility-widget.module').then(m => m.UtilityWidgetModule),
    canActivate: [AuthGuard],
    data: {
      /*
       * INFO: Wenn die Fehlermeldungen manuell embedded werden sollen, hier true. Ansonsten wird per redirect die
       * Route auf die error-Seite umgeleitet.
       */
      embedErrors: true,
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'widget/beleguebersicht',
    loadChildren: () => import('./modules/widget/beleguebersicht-widget/beleguebersicht-widget.module')
      .then(m => m.BeleguebersichtWidgetModule),
    canActivate: [AuthGuard],
    data: {
      embedErrors: true,
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  {
    path: 'impressum',
    loadComponent: () => import('./modules/impressum/impressum.component').then(m => m.ImpressumComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'error',
    loadChildren: () => import('./modules/error-pages/error-pages.module').then(m => m.ErrorPagesModule),
    canActivate: [AuthGuard],
    data: {
      redirectAllowed: true,
      useInhaberService: true,
    },
  },
  PdfViewerRoute,
  {
    path: '**',
    redirectTo: '/overview'
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
